"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { sendDownloadEvent } from "../../ga4/eventHandler";

export default function SupportCard({ machine }) {
  console.log(machine);
  return (
    <div className="support-card">
      <div className="support-card-heading">
        {machine.attributes.isFloorMachine ? (
          <h3>Floor Machines</h3>
        ) : (
          <h3>{machine.attributes.name}</h3>
        )}
      </div>
      <div className="support-card-image">
        <Image
          src={machine.attributes.main_image.data.attributes.url}
          alt={`Kodiak - ${machine.attributes.name} - ${machine.attributes.style.data.attributes.style} render`}
          width={500}
          height={500}
        />
      </div>
      <div className="manuals-wrapper">
        {machine.attributes.manuals.map((manual) => (
          <div
            className="manual"
            key={manual.id}
            onClick={() => {
              sendDownloadEvent(
                machine.attributes.name,
                manual.manual_type.data.attributes.name
              );
              window.open(manual.url, "_blank");
            }}
          >
            <div className="manual-image-wrapper">
              <ManualSVG
                url={
                  manual.manual_type.data.attributes.image.data.attributes.url
                }
                alternativeText={
                  manual.manual_type.data.attributes.image.data.attributes
                    .alternativeText ||
                  `Kodiak - ${manual.manual_type.data.attributes.name} Manual`
                }
              />
            </div>
            <h4>{manual.manual_type.data.attributes.name}</h4>
          </div>
        ))}
      </div>
    </div>
  );
}

function ManualSVG({ url, alternativeText }) {
  const [svgContent, setSvgContent] = useState(null);

  useEffect(() => {
    fetchSVGContent(url).then((content) => {
      setSvgContent(content);
    });
  }, [url]);

  const fetchSVGContent = async (svgUrl) => {
    try {
      const response = await fetch(svgUrl);
      const svg = await response.text();
      return svg;
    } catch (error) {
      console.error("Failed to fetch SVG:", error);
      return null;
    }
  };

  if (!svgContent) return null;

  return (
    <div
      dangerouslySetInnerHTML={{ __html: svgContent }}
      aria-label={alternativeText}
    />
  );
}
